import { render, staticRenderFns } from "./LeadVCJP.vue?vue&type=template&id=40d80d0c"
import script from "./LeadVCJP.vue?vue&type=script&lang=js"
export * from "./LeadVCJP.vue?vue&type=script&lang=js"
import style0 from "./LeadVCJP.vue?vue&type=style&index=0&id=40d80d0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports